<template>
  <v-menu offset-y class="AddToCalendarMenu">
    <template v-slot:activator="{ on }">
      <slot :on="on" />
    </template>
    <v-list>
      <v-list-item
        v-for="(calendar, index) in calendars"
        :key="index"
        :data-e2e="`${calendar.title}CalendarLink`"
        :href="`${calendar.link}`"
        target="_blank"
      >
        <v-list-item-icon>
          <v-icon>{{ calendar.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ calendar.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { google, outlook, office365, yahoo, ics } from 'calendar-link'
import { mapGetters } from 'vuex'

export default {
  name: 'AddToCalendarMenu',

  props: {
    appointment: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['currentShop']),
    calendars() {
      return [
        { icon: 'mdi-calendar', title: 'iCal', link: ics(this.event) },
        { icon: 'mdi-microsoft-office', title: 'Office 365', link: office365(this.event) },
        { icon: 'mdi-microsoft-outlook', title: 'Outlook', link: outlook(this.event) },
        { icon: 'mdi-yahoo', title: 'Yahoo', link: yahoo(this.event) },
        { icon: 'mdi-google', title: 'Google', link: google(this.event) }
      ]
    },
    event() {
      return {
        description: '',
        end: this.appointment.end,
        start: this.appointment.start,
        title: this.appointment.name
      }
    }
  }
}
</script>
